import { ShieldCheck, FileCheck2, Target } from 'lucide-react';

const cards = [
  { icon: Target,      label: 'Intent',     sub: 'Clear outcome\nbefore action' },
  { icon: FileCheck2,  label: 'Evidence',   sub: 'Proof attached\nto every result' },
  { icon: ShieldCheck, label: 'Governance', sub: 'Controls that\nstay accountable' },
];

/**
 * Rotating card deck: 3 cards cycle through centre/left/right, each representing
 * a TICCA operating pillar. Pure CSS animation via ticca-rotating keyframes.
 */
export function RotatingCards() {
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="ticca-wrap-card">
        {cards.map(({ icon: Icon, label, sub }) => (
          <div key={label} className="ticca-rc">
            <div className="relative flex h-full w-full flex-col items-center justify-center gap-3 rounded-xl p-4 text-center">
              <Icon className="h-8 w-8 text-white drop-shadow-lg" strokeWidth={1.5} />
              <div>
                <div className="font-semibold text-white drop-shadow">{label}</div>
                <div className="mt-1 whitespace-pre-line text-white/75">{sub}</div>
              </div>
            </div>
          </div>
        ))}

        {/* SVG gradient defs (shared, hidden) */}
        <svg style={{ visibility: 'hidden', width: 0, height: 0 }}>
          <defs>
            <linearGradient id="rc-grad" x1="0%" y1="0%" x2="120%" y2="120%">
              <stop offset="0%" stopColor="#ffffff" />
              <stop offset="100%" stopColor="#ffffff00" />
            </linearGradient>
          </defs>
        </svg>

        {/* bottom glow lines */}
        <div className="ticca-lines">
          <div className="ticca-line" />
          <div className="ticca-line" />
        </div>
      </div>
    </div>
  );
}
